export const environment = {
  production: false,

  HttpUrl: [
    'https://vuwnwhdth3.execute-api.us-east-1.amazonaws.com/ApprobeDev',
  ],
  HttpEvidente: [
    'https://test.approbe.co/articulator-service/lominco/data/evidente',
  ],
  urlPayment: {
    url: 'https://paymentstest.approbe.co/',
  },
  urlAwsImg: 'https://image-bnpl.s3.amazonaws.com',
  typeId: 1,
  descriptionId: 'CC',
  urlWebSite: 'https://develop.approbe.co/',
  updateAuthorization:
    'https://vuwnwhdth3.execute-api.us-east-1.amazonaws.com/ApprobeDev/updateAuthorization',
  googleApiKey: 'AIzaSyDkY1pFXSweQR6g4pkQFkPqlLJpmJO5Zak',
  urlServices: 'https://test.approbe.co',
};
